module.exports = __webpack_public_path__ + "img/joystick.d49ea363.svg";